var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.categoryExits)?_c('div',{class:_vm.classes,on:{"click":_vm.toggle}},[_c('div',[_vm._v(_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }